import { render, staticRenderFns } from "./M13.vue?vue&type=template&id=40084af1&scoped=true"
import script from "./M13.vue?vue&type=script&lang=js"
export * from "./M13.vue?vue&type=script&lang=js"
import style0 from "./M13.vue?vue&type=style&index=0&id=40084af1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40084af1",
  null
  
)

export default component.exports